import React, {useState, useCallback} from 'react';
import {view, Action, Icon, Skeleton} from '@sail/ui';
import {clipboard, checkCircle} from '@sail/icons/react/Icon';
import {Text} from 'src/v2/components/common/Text';
import {COLORS} from 'src/v2/util/color';
import type {CssProperties} from '@sail/ui';

interface LabelValueCopyRowProps {
  label: React.ReactNode;
  value: string;
  onCopy: () => void;
  valueStyle?: CssProperties;
  containerStyle?: CssProperties;
  contentContainerStyle?: CssProperties;
  loading?: boolean;
}

export const LabelValueCopyRow: React.FC<LabelValueCopyRowProps> = ({
  label,
  value,
  onCopy,
  valueStyle,
  containerStyle,
  contentContainerStyle,
  loading,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(() => {
    onCopy();
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  }, [onCopy]);
  return (
    <view.div
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'xsmall',
        ...containerStyle,
      }}
    >
      {/* Title/Label */}
      <Text
        type="body"
        css={{
          color: COLORS.textDisabled,
        }}
      >
        {label}
      </Text>

      {/* Content/Value with Clipboard Icon */}
      <view.div
        css={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 'medium',
          ...contentContainerStyle,
        }}
      >
        {loading ? (
          <Skeleton css={{height: 'space.250', flex: 1, ...valueStyle}} />
        ) : (
          <Text
            type="bodyEmphasized"
            css={{
              wordBreak: 'break-all',
              color: COLORS.textPrimary,
              flex: 1,
              ...valueStyle,
            }}
          >
            {value}
          </Text>
        )}

        {/* Clipboard Icon */}
        <Action onPress={handleCopy}>
          <Icon
            icon={isCopied ? checkCircle : clipboard}
            size="small"
            css={{
              cursor: 'pointer',
              flexShrink: 0,
            }}
          />
        </Action>
      </view.div>
    </view.div>
  );
};
